import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

// Second line of defence: never let API request/response bodies (customer
// details) leave the browser, even if a caller attaches them again.
export const scrubEvent = (event) => {
  const apiError = event?.contexts?.["API Error"];
  if (apiError) {
    delete apiError.requestData;
    delete apiError.responseData;
  }
  if (event?.request) delete event.request.data;
  return event;
};

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.1,
  beforeSend(event, hint) {
    const error = hint.originalException;

    if (error?.message?.includes("token")) return null;

    return scrubEvent(event);
  },
});

export default Sentry;
